import { render, staticRenderFns } from "./PruningGroups.vue?vue&type=template&id=5ec12ed6&scoped=true&lang=html&"
import script from "./PruningGroups.vue?vue&type=script&lang=js&"
export * from "./PruningGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec12ed6",
  null
  
)

export default component.exports